import { Card, CbhIcon, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";

export function ShortLeadTimeShiftInfo() {
  return (
    <Card variant="quaternary">
      <CardContent>
        <Stack sx={{ flexDirection: "column", gap: 3 }}>
          <Stack sx={{ alignItems: "center", flexDirection: "row", gap: 2 }}>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              Last minute shifts
            </Text>

            <CbhIcon type="info" size="small" />
          </Stack>

          <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            If you book a shift that starts very soon, we&apos;ll share a target arrival time based
            on your driving distance from the workplace. You&apos;ll get points for arriving by this
            time and penalties if you arrive 15+ minutes late.
          </Text>
        </Stack>
      </CardContent>
    </Card>
  );
}
